import * as React from "react";

import { H6, SpanInline } from 'components/CustomTypography';
import CustomImageBox from 'components/CustomImageBox';

import "./SellerCategory.scss";
import {Box, Card, IconButton, Typography} from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import { H2, H3, H4, H5 } from 'components/CustomTypography';
import {getImage} from "helpers/utils";
import LazyImage from "components/LazyImage";


const AdminCommonCategory = (props) => {
  const { category = {}, editCategoryImage, editCategoryInfo, editCategorySettings, className = "" } = props;
  const { name, parent, children = [] } = category;

  const parentName = parent && typeof parent === "object" && parent.name
    ? parent.name
    : null;
  const childList = Array.isArray(children) ? children : [];

  const childNames = childList.map((c) => {
        if (!c || !c.name) return ""; // Handle missing data

        const status = c.is_active ? "(A)" : "(D)";
        return `${c.name} ${status}`;
    });

  const childSummary = childNames.length ? childNames.join(" | ") : "—";

  return (
      <Box width="100%" display="flex" p={1}>
          <Box width="20%" order={1} onClick={editCategoryImage}>
              <LazyImage
                  src={getImage(category.image)}
                  width={150}
                  height={150}
                  mx="auto"
              />
          </Box>
          <Box width="60%" order={1} ml={2}>
              <H4><b>{name}</b></H4>
              <H6 fontSize={12}>{category.is_active ? "ACTIVE" : "DISABLED"} / {category.gender}</H6>
              <H6 fontSize={12}>{category.uid} / {category.slug}</H6>
              <H5 fontSize={14}>
                  <b>Parent:</b> {parentName || "—"}
              </H5>
              <H5 fontSize={12}>
                  <b>Children</b> ({childNames.length}): {childSummary}
              </H5>
          </Box>
          <Box width="20%" order={1} ml={2}>
              <IconButton  className="setting-button" color="primary" size="small" onClick={editCategorySettings}>
                  <MoreHorizIcon />
              </IconButton>
              <IconButton  className="setting-button" color="primary" size="small" onClick={editCategoryInfo}>
                  <EditIcon />
              </IconButton>

          </Box>
      </Box>
  );
};

export default AdminCommonCategory;
